/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

module.exports = {
  strings: {
    generatingThumbnails: 'Generating thumbnails...'
  }
};
